// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const shaymin_land: PokeData = {
  "id": 492,
  "name": "shaymin-land",
  "height": 2,
  "weight": 21,
  "base_experience": 270,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "leech-seed",
    "growth",
    "sleep-powder",
    "quick-attack",
    "recover",
    "defense-curl",
    "sweet-kiss",
    "sweet-scent",
    "synthesis",
    "aromatherapy",
    "grass-whistle",
    "magical-leaf",
    "healing-wish",
    "natural-gift",
    "lucky-chant",
    "worry-seed",
    "air-slash",
    "energy-ball",
    "earth-power",
    "seed-flare",
    "grassy-terrain",
    "play-rough",
    "leafage"
  ],
  "moves": [
    "quick-attack",
    "sweet-kiss",
    "synthesis",
    "aromatherapy",
    "healing-wish",
    "air-slash",
    "energy-ball",
    "earth-power",
    "grassy-terrain",
    "play-rough",
    "frenzy-plant",
    "wood-hammer",
    "razor-leaf"
  ],
  "evolution_chain": {
    "id": 253,
    "item": null,
    "species": [
      {
        "name": "shaymin",
        "order": 493,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 133,
    "ability_power": 133
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
